// import { SWRConfig } from "swr";
import Article from "../../containers/Article/Article";

const ArticlePage = (props) => {
  return <Article {...props} />;
};

export const getServerSideProps = async ({ params }) => {
  const res = await fetch(process.env.API_URL + "/articles/" + params.slug);
  const article = await res.json();
  const res2 = await fetch(
    process.env.API_URL + "/articles/getThreeLast/" + params.slug
  );
  const articles = await res2.json();

  return {
    props: {
      article,
      articles,
    },
  };
};

// export async function getStaticProps({ params }) {
//   // const res = await fetch(process.env.API_URL + "/articles");
//   // const articles = await res.json();

//   const res = await fetch(process.env.API_URL + "/articles/" + params.slug);
//   const article = await res.json();
//   const res2 = await fetch(
//     process.env.API_URL + "/articles/getThreeLast/" + params.slug
//   );
//   const articles = await res2.json();

//   return {
//     props: {
//       article,
//       articles,
//     },
//     revalidate: 60,
//   };
// }

// export async function getStaticPaths() {
//   const res = await fetch(process.env.API_URL + "/articles");
//   const articles = await res.json();

//   const paths = articles.map((article) => ({
//     params: { slug: article.slug },
//   }));

//   return { paths, fallback: "blocking" };
// }

// const ArticlePage = ({ fallback }) => {
//   return (
//     <SWRConfig value={{ fallback }}>
//       <Article />
//     </SWRConfig>
//   );
// };
// export async function getStaticProps({ params }) {
//   const res = await fetch(
//     process.env.API_URL + "/articles/" + params.slug
//   );
//   // try {
//     const article = await res.json();
//   // } catch (error) {
//   //   return {
//   //     notFound: true,
//   //   };
//   // }
//   const res2 = await fetch(
//     process.env.API_URL + "/articles/getThreeLast/" + params.slug
//   );
//   const articles = await res2.json();

//   return {
//     props: {
//       fallback: {
//         [process.env.API_URL + "/articles/" + params.slug]: article,
//         [process.env.API_URL + "/articles/getThreeLast/" + params.slug]:
//           articles,
//       },
//     },
//     revalidate: 60,
//   };
// }

// export async function getStaticPaths() {
//   const res = await fetch(process.env.API_URL + "/articles");
//   const articles = await res.json();

//   const paths = articles.map((article) => ({
//     params: { slug: article.slug },
//   }));

//   return { paths, fallback: "blocking" };
// }

export default ArticlePage;
